import React from 'react'

export const InfoIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 9C18 13.9702 13.9699 18 9 18C4.02902 18 0 13.9707 0 9C0 4.02928 4.02902 0 9 0C13.9699 0 18 4.02981 18 9ZM9 7.125C9.20711 7.125 9.375 7.29289 9.375 7.5V12.375H10.5C10.7071 12.375 10.875 12.5429 10.875 12.75C10.875 12.9571 10.7071 13.125 10.5 13.125H7.5C7.29289 13.125 7.125 12.9571 7.125 12.75C7.125 12.5429 7.29289 12.375 7.5 12.375H8.625V7.875H7.875C7.66789 7.875 7.5 7.70711 7.5 7.5C7.5 7.29289 7.66789 7.125 7.875 7.125H9ZM8.625 6C9.03921 6 9.375 5.66421 9.375 5.25C9.375 4.83579 9.03921 4.5 8.625 4.5C8.21079 4.5 7.875 4.83579 7.875 5.25C7.875 5.66421 8.21079 6 8.625 6Z"
				fill="#62BDD0"
			/>
		</svg>
	)
}
